import { cva } from 'class-variance-authority';

export const variant = {
  active: 'bg-secondary',
  inactive: 'bg-neutral-muted',
  warning: 'bg-warning',
  error: 'bg-destructive',
};

export const statusDotVariants = cva('size-2 rounded-full', {
  variants: {
    variant,
  },
  defaultVariants: {
    variant: 'active',
  },
});
